/* eslint-disable react/no-did-mount-set-state */

import React from 'react';
import moment from 'moment';

import createNodeKey from 'utils/react/createNodeKey.util';

import ItemUnlock from 'checkout/components/deposit/ItemUnlock';

class ItemContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      appointmentsCalled: false,
      items: null,
      unlockedApptId: [-1],
    };
  }

  componentDidMount() {
    if (
      this.props.items &&
      this.props.items.locked_on_appointments &&
      this.props.items.locked_on_appointments.length &&
      !this.state.appointmentsCalled
    ) {
      this.setState({ appointmentsCalled: true });
      this.props.getAppointmentStartTimeList(
        this.props.salonId,
        this.props.items.locked_on_appointments.map((a) => a.appointment),
      );
      if (this.props.searchDepositAdded) {
        /* for (let i = 0; i < this.props.items.length; i += 1) {
          const item = {
            id: 10,
            date: moment().format('Do MMM YYYY'),
            amount: 20,
          };
          items.push(item);
        } */
        // this.setState({ items: [...this.state.items, this.props.items] });
      }

      this.props.fetchClientDepositDetails(this.props.salonId, this.props.items.clientId);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps, nextState) {
    // wait a second for didMount setState to finish
    setTimeout(() => {
      if (
        nextProps.items &&
        nextProps.items.locked_on_appointments &&
        nextProps.items.locked_on_appointments.length &&
        !nextState.appointmentsCalled &&
        !this.state.appointmentsCalled
      ) {
        this.setState({ appointmentsCalled: true });
        this.props.getAppointmentStartTimeList(
          this.props.salonId,
          nextProps.items.locked_on_appointments.map((a) => a.appointment),
        );
        this.props.fetchClientDepositDetails(this.props.salonId, this.props.items.clientId);
      }
    }, 1000);

    if (nextProps.depositUnlock && Object.values(nextProps.depositUnlock).length) {
      const unlockedApptId = Object.entries(nextProps.depositUnlock)
        .filter((e) => e[1] === 'Success')
        .map((e) => parseInt(e[0], 10));

      if (unlockedApptId !== this.state.unlockedApptId) {
        this.setState({ unlockedApptId });
      }
    }
    const items = [];
    if (
      nextProps.appointmentStartTimeList.length &&
      nextProps.clientDepositData &&
      nextProps.clientDepositData.response
    ) {
      const timeList = nextProps.appointmentStartTimeList;
      for (let i = 0; i < timeList.length; i += 1) {
        const depositForAppointment = nextProps.clientDepositData.response.deposits_list.filter(
          (d) => d.created_for_appointmentId === timeList[i].id,
        )[0];
        const amount = depositForAppointment ? depositForAppointment.amount : 0;
        const item = {
          id: parseInt(timeList[i].id, 10),
          date: moment(timeList[i].start_time).format('Do MMM YYYY'),
          amount,
        };
        items.push(item);
      }
      if (!this.state.items) {
        this.setState({ items });
      }
    }
  }

  onClose = () => void this.props.onClose();

  render() {
    const { t } = this.props;

    return (
      <>
        <div className="disable-click-outside-overlay" />
        <div className="unlock-modal-container">
          <div className="inner-items">
            <div className="header-flex-3-colmn">
              <span>{t('checkout.clientsDepositTable.unlockedDepositModal.appointmentDate')}</span>
              {/* <span>Services booked</span> */}
              <span>{t('checkout.clientsDepositTable.unlockedDepositModal.amountDeposited')}</span>
            </div>
            <ul>
              {this.state.items &&
                this.state.items.map((item, index) => {
                  let unlocked = false;
                  if (this.state.unlockedApptId.indexOf(item.id) >= 0) {
                    unlocked = true;
                  }

                  return (
                    <ItemUnlock
                      key={createNodeKey({ unique: item.id, index, tag: 'ItemUnlock' })}
                      date={item.date}
                      index={index}
                      id={item.id}
                      services={item.services}
                      amount={item.amount}
                      salonId={this.props.salonId}
                      unlocked={unlocked}
                      styles={unlocked ? 'btn-is-released' : ' '}
                      buttonText={
                        unlocked
                          ? t('checkout.clientsDepositTable.unlockedDepositModal.depositReleased')
                          : t('checkout.clientsDepositTable.unlockedDepositModal.releasedDeposit')
                      }
                      unlockDeposit={this.props.unlockDeposit}
                    />
                  );
                })}
            </ul>
          </div>
          <div className="modal-footer">
            <button onClick={this.onClose} className="btn btn-violet">
              {t('checkout.clientsDepositTable.unlockedDepositModal.returnButton')}
            </button>
          </div>
        </div>
      </>
    );
  }
}

export default ItemContainer;
